module.exports = __webpack_public_path__ + "assets/218e51a99a47d987094f45512e47fcf0.jpg";